import { createSlice } from '@reduxjs/toolkit';
import api from 'src/api/index';
import i18n from 'src/i18n';
import { showErrorToast } from './toast';

const initialState = {
	list: [],
	draft: null,
	loading: false
};

const lecturesSlice = createSlice({
	name: 'lectures',
	initialState,
	reducers: {
		setLecturesList: (state, action) => {
			state.list = action.payload;
		},
		addLecturesItem: (state, action) => {
			state.list.push(action.payload);
		},
		setLectureDraft: (state, action) => {
			if (state.draft) {
				state.draft = { ...state.draft, ...action.payload };
			} else {
				state.draft = action.payload;
			}
		},
		setLectureLoading: (state, action) => {
			state.loading = action.payload; 
		},
		removeLecturesItem: (state, action) => {
			state.list = state.list.filter((item) => action.payload !== item.id);
		},
		updateLectureItem: (state, action) => {
			const index = state.list.findIndex(item => item.id === action.payload.id);
			if (index !== -1) {
				state.list.splice(index, 1, action.payload);
			}
		}
	},
});

export const { setLecturesList, addLecturesItem, removeLecturesItem, updateLectureItem, setLectureDraft, setLectureLoading } = lecturesSlice.actions;

export const fetchLecturesList = () => async (dispatch) => {

	try {

		const res = await api.lecturesList();
		dispatch(setLecturesList(res.list));

	} catch (error) {

		throw error;
			
	}
};

export const updateLecture = (lecture) => async (dispatch) => {

	dispatch(setLectureLoading(true));

	try {

		const res = await api.updateLecture( lecture );

		if (res) {
			dispatch(reloadLecture(lecture.id));
		}

	} catch (error) {

		console.error(error);

		dispatch(showErrorToast({
			description: i18n.t('toasts.failedUpdateLecture')
		}));

		throw error;

	} finally {

		dispatch(setLectureLoading(false));

	}

};

export const reloadLecture = (lectureId) => async (dispatch) => {

	dispatch(setLectureLoading(true));

	try {

		const course = await api.lectureById(lectureId);

		if (course) {
			dispatch(updateLectureItem(course));
		}

	} catch (error) {

		console.error(error);

		dispatch(showErrorToast({
			description: i18n.t('toasts.failedUpdateLecture')
		}));

		throw error;

	} finally {

		dispatch(setLectureLoading(false));

	}

};

export const getLectureById = (id) => ( dispatch, getState ) => {

	return new Promise(( resolve, reject ) => {

		const state = getState();

		const list = state.lectures.list;

		let item = list.find(item => item.id === id);

		if (item) {

			resolve(item);

		} else {

			api.lectureById(id)
				.then(res => {
					dispatch(addLecturesItem(res));
					resolve(res);
				})
				.catch(() => {

					dispatch(showErrorToast({
						description: i18n.t('toasts.lectureNotFound', { id })
					}));

					reject();

				});
		}

	});

};

export default lecturesSlice.reducer;
